export class RemedialModel {

  remedialUid: number;
  name: string;
  stlCode: string;
  charge: string;
  assetObservationRemedialUid: number;
  assetObservationCustomRemedialUid: number;

  quantity: number = 0;
  selected: boolean;

  constructor() {

    this.quantity = 0;
  }
}